import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import isMobilePhone from 'validator/lib/isMobilePhone';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

import {
    // IconButton,
    Button,
    OutlinedInput,
    InputLabel,
    InputAdornment,
    FormControl,
    Divider,
    // FormHelperText,
    CircularProgress,
} from "@material-ui/core";


import { auth, firefunctions } from '../../../components/firebase/FirebaseProvider';
import PayungTerbang from "../../../assets/images/login-payung-terbang.svg";
import Gelombang from "../../../assets/images/login-gelombang.svg";
import tokoAll from "../../../assets/images/login-tokoo.svg";

import useStyles from "./style";
import Header from "../../../components/molecules/navbarLogReg";
import Header1 from "../../../components/molecules/LoginNav/header";

import Footer from "../../../components/molecules/LoginNav/footer";
import { WhatsApp } from '@material-ui/icons';

import ReCAPTCHA from 'react-google-recaptcha';
import recaptchaSiteKey from '../../../config/Google/recaptcha';


function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
    // console.log(props)
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['+', /[1-9]/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            guide={false}
        />
    );
}

TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
};


function Register() {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory()
    const [year] = useState(new Date().getFullYear());
    const matches = useMediaQuery(theme.breakpoints.up('tablet'));
    const [phone, setPhone] = useState();
    const [phoneRaw, setPhoneRaw] = useState();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const source = params.get('utm_source');

    const [recaptchaToken, setRecaptchaToken] = useState(null);

    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
    };

    const requestOtp = async (e) => {
        // console.log('button clicked')
        const exp = /-/g;
        setLoading(true)
        try {
            let phoneRawLocal = phoneRaw
            if (phone) {
                phoneRawLocal = phone.replace(exp, '')
            }

            if (!isMobilePhone(phoneRawLocal)) {
                // console.log('No Whatsapp tidak valid', phoneRawLocal)
                setError('No Whatsapp tidak valid')
                setLoading(false)
                return
            }
            // console.log(phoneRawLocal)
            const callSendOTP = firefunctions.httpsCallable("sendOTP");

            await callSendOTP({
                no_hp: phoneRawLocal,
                mode: "register",
                source,
                recaptcha_token: recaptchaToken
            });
            // console.log(response?.data)

            setPhoneRaw(phoneRawLocal);
            setLoading(false)

            let timeNow = Date.now() + 5 * 60 * 1000

            history.replace(`/register/otp/${phoneRawLocal}/${timeNow}`)

        } catch (error) {
            console.log(error);
            setLoading(false)
            setError(error.message)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (!phone) {
            setError('No Whatsapp wajib diisi');
            return;
        }

        if (!recaptchaToken) {
            setError('Please complete the CAPTCHA.');
            return;
        }
        
        requestOtp();
    }


    const logout = () => {
        if (auth) {
            auth?.signOut();
        }
        history.push("/login")
    };

    return (
        <div className={classes.root}>
            <div className={classes.main}>
                {matches ?
                    <Header1 nameStatus={'Daftar'} />
                    :
                    <Header nameStatus={'Daftar'} />
                }
                <div className={classes.body}>
                    <div className={classes.box}>
                        <div className={classes.box_container}>
                            <div className={classes.box_head}>
                                <div className={classes.box_head_logo}>
                                    <img src={PayungTerbang} alt="payung_terbbangg" />
                                </div>
                                <div className={classes.box_head_text}>
                                    <h1>Daftar Menjadi Reseller</h1>
                                    <p>
                                        Sudah punya akun?
                                        <Link onClick={logout} className={classes.link}>
                                            Masuk Sekarang
                                        </Link>
                                    </p>
                                </div>
                            </div>
                            <Divider />
                            <div className={classes.box_body}>
                                <form className={classes.box_form} autoComplete="off" onSubmit={handleSubmit}>
                                    <FormControl
                                        variant="outlined"
                                        fullWidth
                                        // className={classes.input_form}
                                        style={{ marginBottom: "15px" }}
                                        error={error ? true : false}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-password">
                                            Nomor WA
                                        </InputLabel>
                                        <OutlinedInput
                                            value={phone}
                                            id="outlined-adornment-wa"
                                            label="Nomor WA"
                                            placeholder="+62-852-1234-5678"
                                            onChange={(e) => setPhone(e.target.value)}
                                            disabled={loading}
                                            inputComponent={TextMaskCustom}
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <WhatsApp color="action" />
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                    {error ?
                                        <div style={{ display: 'flex', fontSize: 10, marginTop: -5, justifyContent: 'center', color: 'red' }}>
                                            {error}
                                        </div>
                                        : null}

                                    <div
                                        style={{
                                            display: "flex",
                                            marginTop: "8px"
                                        }}
                                    >
                                        <ReCAPTCHA
                                            sitekey={recaptchaSiteKey}
                                            onChange={handleRecaptchaChange}
                                        />
                                    </div>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={loading}
                                        style={{
                                            position: "relative",
                                            width: "100%",
                                            letterSpacing: "1px",
                                            fontWeight: "bold",
                                            borderRadius: "8px",
                                            paddingTop: "12px",
                                            paddingBottom: "12px",
                                            marginTop: "10px",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {loading === true ?
                                            <CircularProgress size={24} className={classes.buttonProgress} /> :
                                            'Kirim OTP'
                                        }
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <span className={classes.copyright}>
                        © Hak Cipta PT. Tokorame Anugerah Sejahtera - {year}
                    </span>
                    <div className={classes.gelombang}>
                        <img src={Gelombang} alt="gelombang" />
                    </div>
                    <div className={classes.toko}>
                        <img src={tokoAll} alt="tokoo" />
                    </div>
                </div>
            </div >
            {matches ?
                <Footer />
                : null}
        </div >
    )
}
export default Register